import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        container: {
            backgroundColor: 'stokkeCore.white',
            padding: '1rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1rem',
            marginTop: '1rem'
        },
        label: {
            ...textStyles['Semi Bold Medium']
        },
        iconsContainer: {
            display: 'flex',
            gap: '1.125rem',
            flexWrap: 'wrap'
        },
        icon: {
            height: '1rem',
            width: 'auto'
        }
    },
    parts: ['container', 'label', 'iconsContainer', 'icon']
}
